import { defaultMapping } from 'stores/ooka_usa_store/components/OOKA/pylot-gtm/src/mapping/defaultMapping'
import { combineDataMapping } from '@corratech/pylot-gtm/src/mapping/combineDataMapping'
import { applyDataMapping } from '@corratech/pylot-gtm/src/mapping/applyDataMapping'
import type { GTMEventDataMapping } from '@corratech/pylot-gtm/src/GTM.d'
import type { DataLayerInput } from '@corratech/pylot-tag-manager'

type ApplyMapping = (action: DataLayerInput) => DataLayerInput

export const getApplyMapping = (
    customMapping: GTMEventDataMapping
): ApplyMapping => {
    const combinedMapping = combineDataMapping(defaultMapping, customMapping)
    return (action) => {
        return applyDataMapping(action, combinedMapping)
    }
}
